module.exports = __webpack_public_path__ + "static/media/vdg-mockup-1.063f13e5.png";